import type React from "react";
import { memo } from "react";
import { X } from "lucide-react";

const STREAM_SEARCH_CLEAR_BUTTON_CLASS =
  "absolute right-2 top-1/2 -translate-y-1/2 rounded-full p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700";

export type StreamSearchClearButtonProps = {
  ariaLabel: string;
  onClear: () => void;
  className?: string;
};

export const StreamSearchClearButton: React.FC<StreamSearchClearButtonProps> =
  memo(({ ariaLabel, onClear, className }) => (
    <button
      type="button"
      onClick={onClear}
      aria-label={ariaLabel}
      className={className || STREAM_SEARCH_CLEAR_BUTTON_CLASS}
    >
      <X className="size-3.5" />
    </button>
  ));
StreamSearchClearButton.displayName = "StreamSearchClearButton";

export type StreamSearchConditionClearButtonProps = {
  shouldRender: boolean;
  onClear: () => void;
  ariaLabel: string;
  className?: string;
};

export const StreamSearchConditionClearButton: React.FC<StreamSearchConditionClearButtonProps> =
  memo(({ shouldRender, onClear, ariaLabel, className }) =>
    !shouldRender ? null : (
      <StreamSearchClearButton
        ariaLabel={ariaLabel}
        onClear={onClear}
        className={className}
      />
    ),
  );
StreamSearchConditionClearButton.displayName =
  "StreamSearchConditionClearButton";
